import React, { Component, PropTypes } from 'react';
import forEach from 'lodash/forEach';
import trim from 'lodash/trim';
import css from './player.scss';
import ReactPlayer from 'react-player';
import axios from 'axios';
import getOffsetTop from '../../utils/getOffsetTop';
import vimeoImage from './vimeo-logo.png';
import youtubeImage from './youtube-logo.png';

//import css from './content.scss';

const REGEX_EXTRACT_YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
const REGEX_EXTRACT_YT_ID2 = /([a-zA-Z0-9_-]{11})/i;
const REGEX_EXTRACT_VIMEO_ID = /vimeo.*?([0-9]+$)/i;
const REGEX_EXTRACT_VIMEO_ID2 = /(^[0-9]+$)/i;

export class Player extends Component {
	static PropTypes = {
		url: PropTypes.string.isRequired,
		showVideo: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		browser: PropTypes.object.isRequired,
	};

	static defaultProps = {
		url: '',
		showVideo: false,
		onClose: () => {},
	};

	constructor(props) {
		super();

		this.mounted = true;
		this.played = 0;
		this.loaded = 0;
		this.duration = 0;
		this.wasActivated = false;

		this.state = {
			playbackState: false,
			width: 640,
			height: 360,
			volume: 0.4,
			duration: '00;00',
			played: '00:00',
			url: props.url,
			visible: props.showVideo,
			thumb: '',
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.url !== this.props.url ||
			this.state.thumb !== nextState.thumb ||
			this.state.playbackState !== nextState.playbackState ||
			this.state.duration !== nextState.duration ||
			this.state.played !== nextState.played ||
			this.state.visible !== nextState.visible
		);

		// update on init
		if ((!this.props.url.length && nextProps.url.length)) {
			return true;
		}
	}

	componentDidMount() {
		document.addEventListener('webkitfullscreenchange', this.onFullScreenExit, false);
		document.addEventListener('mozfullscreenchange', this.onFullScreenExit, false);
		document.addEventListener('fullscreenchange', this.onFullScreenExit, false);
		document.addEventListener('MSFullscreenChange', this.onFullScreenExit, false);
	}

	componentDidUpdate() {
		if (this.state.visible && !this.wasActivated && this.props.browser.window.width > 719) {
			//document.body.scrollTop = getOffsetTop(this.refs.youtubePlayer) - 50;
			this.wasActivated = true;

			this.setState({
				playbackState: true,
			});
		}
	}

	componentWillMount() {
		if (this.props.vimeo && this.state.thumb == '') {
			getVideoThumb(this.props.url);
		}
	}

	componentWillReceiveProps(nextProps) {
		let newState = { ...this.state };

		if (nextProps.showVideo !== this.state.visible) {
			newState.visible = nextProps.showVideo;
		}

		if (nextProps.vimeo && this.props.url !== nextProps.url) {
			getVideoThumb(this.props.url);
		} else {
			this.setState(newState);
		}
	}

	componentWillUnmount() {
		document.removeEventListener('webkitfullscreenchange', this.onFullScreenExit, false);
		document.removeEventListener('mozfullscreenchange', this.onFullScreenExit, false);
		document.removeEventListener('fullscreenchange', this.onFullScreenExit, false);
		document.removeEventListener('MSFullscreenChange', this.onFullScreenExit, false);

		this.mounted = false;
	}

	render() {
		let youtubeConfig = {
			playerVars: {
				showinfo: 0, // deprecated
				controls: 1,
				fs: 1,
			},
		}

		let vimeoConfig = {
			badge: 0,
			title: 0,
			frameborder: 0,
		}

		if (this.props.youtube) {
			getVideoThumb(this.props.url);
		}

		let overlayClass = 'youtube-overlay';
		let playerClass = 'youtube-player span12 span14-tablet span14-mobile';

		if (this.state.visible) {
			overlayClass = 'youtube-overlay youtube-overlay--active';
			playerClass = 'youtube-player span12 span14-tablet span14-mobile youtube-player--active';
		}

		let playerUrl = this.getVideoUrl(this.props.url);

		return (
			<div className='' onKeyPress={(event) => this.handleKeyDown(event)}>
				<div ref='youtubeOverlay' onClick={() => this.handleHideVideo()} className={overlayClass}></div>

				{this.state.visible && (
					<div ref='youtubePlayer' className={playerClass}>
						{this.getYoutubeID(playerUrl) && (
							<a className='youtube-player__original' href={playerUrl}><img src={youtubeImage.src} /></a>
						) || (
							<a className='youtube-player__original' href={playerUrl}><img src={vimeoImage.src} /></a>
						)}
						<ReactPlayer
							className='player-iframe'
							ref='player'
							height='100%'
							width='100%'
							url={playerUrl}
							playing={this.state.playbackState}
							volume={this.state.volume}
							onProgress={(e) => this.mounted && this.handleProgess(e)}
							onPlay={() => this.mounted && this.setState({ playbackState: true })}
							onPause={() => this.mounted && this.setState({ playbackState: false })}
							youtubeConfig={youtubeConfig}
							vimeoConfig={vimeoConfig}
						/>
					</div>
				)}
			</div>
			);
	}

	getVideoUrl(url) {
		let youtubeID = this.getYoutubeID(trim(url));
		if (youtubeID) {
			return 'https://youtube.com/watch?v=' + youtubeID;
		}

		let vimeoID = this.getVimeoID(trim(url));
		if (vimeoID) {
			return 'https://vimeo.com/' + vimeoID;
		}

		return false;

	}

	getVideoThumb(url) {
		let youtubeID = this.getYoutubeID(trim(url));
		if (youtubeID) {
			return this.getYoutubePreview(youtubeID);
		}

		let vimeoID = this.getVimeoID(trim(url));
		if (vimeoID) {
			return this.getVimeoPreview(vimeoID);
		}

		return false;
	}

	getYoutubeID(url) {
		let extracted = REGEX_EXTRACT_YT_ID.exec(url);

		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		extracted = REGEX_EXTRACT_YT_ID2.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		return false;
	}

	getYoutubePreview(videoID) {
		if (!videoID) {
			return '';
		}

		let previewUrl = `https://img.youtube.com/vi/${videoID}/hqdefault.jpg`;

		return previewUrl;
	}

	getVimeoID(url) {
		let extracted = REGEX_EXTRACT_VIMEO_ID.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		extracted = REGEX_EXTRACT_VIMEO_ID2.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		return false;
	}

	getVimeoPreview(videoID) {
		axios.get('https://vimeo.com/api/v2/video/' + videoID + '.json')
		.then((response) => {
			if (response.data[0].thumbnail_large) {
				if (this.state.thumb !== response.data[0].thumbnail_large) {
					this.mounted && this.setState({
						...this.state,
						thumb: response.data[0].thumbnail_large,
					});
				}
			}
		})
		.catch(function(response) {
			console.log('error fetching vimeo data');
			console.log(response);
		});
	}

	handlePlayPause() {
		this.setState({
			playbackState: !this.state.playbackState,
		});
	}

	handleFullscreen() {
		let target = this.refs.youtubePlayer;

		if (target.getAttribute('fullscreen') == 'yes') {
			target.classList.remove('youtube-player--fullScreen');
			target.setAttribute('fullscreen', 'no');

			function exitFullscreen() {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				}
			}

			// Cancel fullscreen for browsers that support it!
			exitFullscreen();
		} else {
			target.classList.add('youtube-player--fullScreen');
			target.setAttribute('fullscreen', 'yes');

			var requestFullScreen = target.requestFullScreen || target.mozRequestFullScreen || target.webkitRequestFullScreen;
			if (requestFullScreen) {
				requestFullScreen.bind(target)();
			}
		}
	}

	keyPress(e) {
		if (e.which == 27) {
			document.querySelector('.youtube-player').classList.remove('youtube-player--fullScreen');
		}
	}

	onFullScreenExit() {
		if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
			document.querySelector('.youtube-player').classList.remove('youtube-player--fullScreen');
			document.querySelector('.youtube-player').setAttribute('fullscreen', 'no');
		}
	}

	handleVideoToggle() {
		this.setState({
			visible: true,
		});
	}

	handleProgess(e) {
		if (e.played) {
			this.played = e.played;
		}

		if (e.loaded) {
			this.loaded = e.loaded;
		}
	}

	handleHideVideo() {
		this.wasActivated = false;

		this.props.onClose();
		this.setState({
			visible: false,
			playbackState: false,
		});
	}
}

export class PlayerTrigger extends Component {
	static propTypes = {
		url: PropTypes.string.isRequired,
		thumb: PropTypes.string,
		onUpdate: PropTypes.func,
		className: PropTypes.string,
	};

	static defaultProps = {
		url: '',
		thumb: '',
		className: '',
		onUpdate: () => {},
	};

	constructor(props) {
		super(props);

		this.mounted = true;

		this.state = {
			thumb: this.getVideoThumb(props.url),
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.url !== this.props.url) {
			this.setState({
				...this.state,
				thumb: this.getVideoThumb(nextProps.url),
			});
		}
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	componentDidMount() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	render() {
		let className = 'player-toggle';
		let style = {
			backgroundImage: `url('${this.state.thumb}')`,
		};

		if (this.props.className) {
			className += ` ${this.props.className}`;
		}

		return (
			<div className={className} style={style} onClick={this.props.onClick}>
				<img src={this.state.thumb} alt='' />
			</div>
		);
	}

	playVideo() {
		this.props.onClick();
	}

	getVideoThumb(url) {
		const youtubeID = this.getYoutubeID(trim(url));
		if (youtubeID) {
			return this.getYoutubePreview(youtubeID);
		}

		const vimeoID = this.getVimeoID(trim(url));
		if (vimeoID) {
			return this.getVimeoPreview(vimeoID);
		}

		return false;
	}

	getYoutubeID(url) {
		let extracted = REGEX_EXTRACT_YT_ID.exec(url);

		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		extracted = REGEX_EXTRACT_YT_ID2.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		return false;
	}

	getYoutubePreview(videoID) {
		if (!videoID) {
			return '';
		}

		return `https://img.youtube.com/vi/${videoID}/hqdefault.jpg`;
	}

	getVimeoID(url) {
		let extracted = REGEX_EXTRACT_VIMEO_ID.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		extracted = REGEX_EXTRACT_VIMEO_ID2.exec(url);
		if (extracted && extracted.length > 1) {
			return extracted[1];
		}

		return false;
	}

	getVimeoPreview(videoID) {
		axios.get('https://vimeo.com/api/v2/video/' + videoID + '.json')
		.then((response) => {
			if (response.data[0].thumbnail_large) {
				if (this.state.thumb !== response.data[0].thumbnail_large) {
					this.mounted && this.setState({
						...this.state,
						thumb: response.data[0].thumbnail_large,
					});
				}
			}
		})
		.catch(function(response) {
			console.log('error fetching vimeo data');
			console.log(response);
		});
	}
}

export class PlayerWithTrigger extends Component {
	static propTypes = {
		url: PropTypes.string.isRequired,
		browser: PropTypes.object.isRequired,
		className: PropTypes.string,
	};

	static defaultProps = {
		url: '',
		className: '',
	};

	constructor(props) {
		super(props);

		this.state = {
			showVideo: false,
		};
	}

	render() {
		let className = 'player-toggle';

		if (this.props.className) {
			className += ` ${this.props.className}`;
		}

		return (
			<div className={className}>
				<PlayerTrigger
					url={this.props.url}
					onClick={(e) => {
						this.setState({
							...this.state,
							showVideo: !this.state.showVideo,
						});
					}}
				/>

				<Player url={this.props.url} showVideo={this.state.showVideo} browser={this.props.browser} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} />
			</div>
		);
	}
}

export class PlayerButtonTrigger extends Component {
	static propTypes = {
		url: PropTypes.string.isRequired,
		text: PropTypes.string,
		className: PropTypes.string,
		browser: PropTypes.object.isRequired,
	};

	static defaultProps = {
		url: '',
		text: '',
		className: '',
	};

	constructor(props) {
		super(props);

		this.state = {
			showVideo: false,
		};
	}

	render() {
		let className = 'player-toggle-btn';

		if (this.props.className) {
			className += ` ${this.props.className}`;
		}

		return (
			<div className={className}>
				<button
					className='player-toggle-btn__btn'
					onClick={() => this.setState({ ...this.state, showVideo: !this.state.showVideo })}
				>
					{this.props.text}
				</button>
				<Player url={this.props.url} browser={this.props.browser} showVideo={this.state.showVideo} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/video/player.js
 **/